export default __webpack_public_path__ + "static/media/blue-check.bd752334.svg";